import {SpatialEntityData} from '../../../../../pages/geospatial-viewer/model/api';
import {
    EnginDataPrepareService,
    SpatialEntityDataExtended,
    SpatialOutageEntityDataExtended,
} from './engin-data-prepare.service';
import {Injectable} from '@angular/core';
import {Project} from '@core/interfaces/engin/program-management/project';
import {ProjectLayerData} from '../../../../../pages/geospatial-viewer/model/project';
import {GeospatialTooltipType} from '../../../../../pages/geospatial-viewer/model/tooltip.model';
import {OutageEntityDto} from '../../../../../pages/geospatial-viewer/layers/outage-layer';
import {VisualizationType} from '../../../../../pages/geospatial-viewer/model/visualization';

@Injectable()
export class GeospatialService {
    constructor(private enginDataPrepareService: EnginDataPrepareService) {}

    // Data prepare services
    public prepareEnginData(
        data: SpatialEntityData[],
        tooltipType: GeospatialTooltipType = GeospatialTooltipType.NONE,
        visualizationType?: VisualizationType,
    ): SpatialEntityDataExtended[] {
        return this.enginDataPrepareService.prepare(data, tooltipType, visualizationType);
    }

    // Data prepare services
    public prepareOutageData(
        data: OutageEntityDto[],
        tooltipType: GeospatialTooltipType = GeospatialTooltipType.NONE,
        visualizationType?: VisualizationType,
    ): SpatialOutageEntityDataExtended[] {
        return this.enginDataPrepareService.prepareOutage(data, tooltipType, visualizationType);
    }

    public prepareProjectData(data: Project[], currentUserId: string): ProjectLayerData[] {
        return data
            .filter((p: Project) => p.shapeGeoJson != null)
            .map((p: any) => {
                return {
                    ...p,
                    // Spatial data
                    projectOwnedByCurrentUser: p.ownerId === currentUserId,
                    geoJsonGeometry: p.geoJsonGeometry ? p.geoJsonGeometry : JSON.parse(p.shapeGeoJson),
                };
            });
    }
}
